import { CalendlyIntegrationHandler } from "./calendly";
import { ZenDeskORFreshDeskIntegrationHandler } from "./zendesk";

import { DefaultIntegrationHandler, IntegrationHandler } from ".";

export enum IntegrationType {
  CALENDLY = "calendly",
  CALENDAR = "calendar",
  WHATSAPP = "whatsapp",
  MESSENGER = "messenger",
  SLACK = "slack",
  TELEGRAM = "telegram",
  ZENDESK = "zendesk",
  FRESHDESK = "freshdesk",
  ZENDESK_LIVE_AGENT_HANDOFF = "zendesk_live_agent_handoff",
  SALESFORCE_LEADS = "salesforce_leads",
  SALESFORCE_LIVE_AGENT_HANDOFF = "salesforce_live_agent_handoff",
}

export function getIntegrationConfiguration({
  type,
  data,
}: {
  type: IntegrationType;
  data: IntegrationHandler;
}) {
  switch (type) {
    case IntegrationType.CALENDLY:
      return new CalendlyIntegrationHandler(data);
    case IntegrationType.ZENDESK:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    case IntegrationType.FRESHDESK:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    case IntegrationType.ZENDESK_LIVE_AGENT_HANDOFF:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    case IntegrationType.SALESFORCE_LEADS:
      return new ZenDeskORFreshDeskIntegrationHandler(data);
    default:
      return new DefaultIntegrationHandler(data);
  }
}
